import React from 'react';

import Pagination from '@components/Pagination';
import Spinner from '@components/Spinner';
import { useSearchResults } from '@hooks';
import { SCOPE_ARTICLES, SCOPE_DIRECTORY, SCOPE_FORUM } from '@hooks/useSearchResults';
import { search_page_path } from '@routes';
import { PaginationType } from '@utils/backend-api/subscriber_directory';

import SearchArticlesList from './ArticlesList';
import SearchExamples from './Examples';
import SearchHeader from './Header';
import SearchPostsList from './PostsList';
import SearchBar from './SearchBar';
import SearchTabs from './SearchTabs';
import SearchSubscribersList from './SubscribersList';
import { SearchPageProps } from './index';
import styles from './styles.module.scss';

const SearchContent = ({
  articleContent,
  page,
  pageCount,
  query,
  scope,
  title,
  topEntities,
  topRelatedEntities,
}: SearchPageProps) => {
  const { data, isLoading } = useSearchResults(page, query, scope);

  if (isLoading) {
    return <Spinner />;
  }

  const isSearchLandingPage = !query && topEntities;
  const isArticleScope = scope === SCOPE_ARTICLES;
  const isForumScope = scope === SCOPE_FORUM;
  const isDirectoryScope = scope === SCOPE_DIRECTORY;

  const totalPages = isArticleScope ? pageCount : data?.totalPages ?? 1;

  const paginationData: PaginationType = {
    page,
    totalPages: totalPages,
    hasNextPage: page < totalPages,
    nextPage: page + 1,
  };

  return (
    <>
      <SearchBar isSearchLandingPage={!!isSearchLandingPage} scope={scope} />
      {isSearchLandingPage && <SearchExamples />}
      {!!query && (
        <>
          <SearchHeader title={title} topRelatedEntities={topRelatedEntities} />
          <SearchTabs query={query} scope={scope} />
          <div className={styles.feedSection}>
            {isArticleScope && <SearchArticlesList content={articleContent} />}
            {isForumScope && <SearchPostsList content={data.forum_posts} />}
            {isDirectoryScope && (
              <SearchSubscribersList
                content={{
                  profiles: data?.profiles,
                  currentUserId: data?.currentUserId,
                }}
              />
            )}
          </div>
          {totalPages > 1 && (
            <Pagination
              getPath={(page) => search_page_path({ query, scope, page })}
              paginationData={paginationData}
            />
          )}
        </>
      )}
    </>
  );
};

export default SearchContent;
